// @ts-nocheck
/* eslint-disable no-use-before-define */
import React, { useMemo } from 'react'
import * as PropTypes from 'prop-types'
import { CircularProgress } from '@mui/material'

import { size, uniqueId, noop, defaultsDeep } from 'lodash'
// Data
import { useI18n } from '@ggs/i18n'
import { Button } from '@mui/material'
// Components
// import { Button } from '../../nav'

const propTypes = {
  data: PropTypes.shape({
    buttonTheme: PropTypes.string,
    buttonLabel: PropTypes.string,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        theme: PropTypes.string,
        type: PropTypes.string,
        label: PropTypes.string,
        disabled: PropTypes.bool,
        displayed: PropTypes.bool,
        onClick: PropTypes.func,
        loading: PropTypes.bool,
      })
    ),
  }),
  formik: PropTypes.shape({
    isSubmitting: PropTypes.bool,
    isValidating: PropTypes.bool,
    handleSubmit: PropTypes.func,
  }),
}

const defaultProps = {
  data: {
    buttonTheme: '',
    buttonLabel: '',
    actions: [],
  },
  formik: {
    isSubmitting: false,
    isValidating: false,
    handleSubmit: noop,
  },
}

const FormActions = ({ actions, formik: { isSubmitting, handleSubmit, isValidating } }) => {
  const { t } = useI18n()
  const defaultActionProps = {
    label: t('Submit'),
    // variant: 'contained',
    disabled: false,
    displayed: true,
  }

  const actionList = useMemo(() => (size(actions) ? actions : []), [actions])
  // console.debug('render', { isSubmitting, isValidating }, actionList)
  return actionList.map((item, index) => {
    defaultsDeep(item, defaultActionProps)
    // console.log('actionItem', item, defaultActionProps)
    switch (item.type) {
      case 'button':
        return (
          <div className="action-item" key={uniqueId(`action-item__${item.label}`)}>
            <Button
              className={`form__action-button ${item.className}`}
              variant={item.variant}
              data-displayed={item.displayed}
              type="button"
              onClick={!item.loading && item.onClick ? item.onClick : null}
              href={item.href}
              data-loading={item.loading}
              disabled={item.disabled || isSubmitting || isValidating}
              endIcon={item.endIcon}
            >
              {item.loading && (
                <span className="form__action-loader">
                  <CircularProgress size={30} />
                </span>
              )}
              <span
                className="form__action-label"
                dangerouslySetInnerHTML={{ __html: item.label }}
              />
            </Button>
          </div>
        )
      default:
        return (
          <div className="action-item" key={uniqueId(`action-item-${index}_`)}>
            <Button
              className={`form__action-submit form__action-button ${item.className}`}
              variant={item.variant}
              data-displayed={item.displayed}
              type="submit"
              onClick={handleSubmit}
              disabled={item.disabled || isSubmitting || isValidating}
              data-loading={isSubmitting || item.loading}
              endIcon={item.endIcon}
            >
              {(isSubmitting || item.loading) && (
                <span className="form__action-loader">
                  <CircularProgress size={30} />
                </span>
              )}
              <span
                className="form__action-label"
                dangerouslySetInnerHTML={{ __html: item.label }}
              />
            </Button>
          </div>
        )
    }
  })
}

FormActions.defaultProps = defaultProps
FormActions.propTypes = propTypes
export default FormActions
